/**
 * 訂單 mock 資料。
 * 對應 API: GET /api/orders, GET /api/orders/:id
 */
export const ORDERS = [
  {
    id: 'MD-20251108-0428',
    createdAt: '2025-11-08 22:14',
    status: 'processing', statusLabel: '準備出貨',
    total: 2260, picCount: 3,
    kind: 'physical', items: 'DYNASTY EFFECT TYPE-K 21g + 鏢翼 ×2',
  },
  {
    id: 'MD-20251023-0317',
    createdAt: '2025-10-23 14:02',
    status: 'shipping',  statusLabel: '運送中',
    total: 1580, picCount: 2,
    kind: 'physical', items: 'COSMO DARTS DISCOVERY 20g',
  },
  {
    id: 'MD-20251005-0244',
    createdAt: '2025-10-05 11:48',
    status: 'delivered', statusLabel: '已送達',
    total: 980,  picCount: 1, canReview: true,
    kind: 'physical', items: 'TARGET RAPTOR 22g 鎢90%',
  },
  {
    id: 'MD-20250920-0192',
    createdAt: '2025-09-20 19:33',
    status: 'review',    statusLabel: '待評價',
    total: 540,  picCount: 2, canReview: true,
    kind: 'virtual', items: '極光主題 AURORA + 霓虹東京 NEON TOKYO',
  },
];

/**
 * 物流時間軸（單一訂單）。後端真實 API 會把 timeline 包在 order 物件內。
 */
export const SAMPLE_TIMELINE = [
  { done: true,  label: '訂單已建立',     time: '2025/11/10 22:14' },
  { done: true,  label: '付款確認',       time: '2025/11/10 22:15' },
  { done: false, label: '備貨中',         time: '預計明日完成' },
  { done: false, label: '出貨 · 黑貓快遞', time: '預計 11/12' },
  { done: false, label: '送達',           time: '預計 11/12–13' },
];
